import React, { useEffect, useRef } from "react";

import { ALL_CATEGORY_KEY } from "../accessoryMappers";

export const CategoryChips = ({ chips, selected, onSelect }) => {
  const activeRef = useRef(null);

  useEffect(() => {
    activeRef.current?.scrollIntoView({
      behavior: "smooth",
      inline: "nearest",
      block: "nearest",
    });
  }, [selected]);

  return (
    <div className="acc-tabs-track" role="tablist" aria-label="Accessory categories">
      {chips.map((chip) => {
        const active = (selected || ALL_CATEGORY_KEY) === chip.key;

        return (
          <button
            key={chip.key}
            ref={active ? activeRef : null}
            type="button"
            role="tab"
            aria-selected={active}
            className={`acc-tab${active ? " is-selected" : ""}`}
            onClick={() => onSelect(chip)}
          >
            {chip.label}
          </button>
        );
      })}
    </div>
  );
};

export const LocationPrompt = ({ locating, onLocate }) => (
  <div className="acc-location-prompt">
    <p>
      Distances and delivery areas need your location. Everything is shown as
      available until you share it.
    </p>

    <button type="button" onClick={onLocate} disabled={locating}>
      {locating ? "Finding you…" : "Show what delivers to me"}
    </button>
  </div>
);
